import { PageTemplate } from '@ui/templates';
import styles from './styles.module.css';

export const PricesPage = () => {
  return <PageTemplate header="Цены"></PageTemplate>;
};
